<template>
  <button class="btn tool-btn" @click="$emit('onClick', type)">
    <img :src="require('@/assets/img/toolbar/' + type + '.png')" />{{
      $t("tool." + type)
    }}
  </button>
</template>

<script>
export default {
  props: {
    type: String
  }
};
</script>

<style scoped lang="scss">
.tool {
  cursor: pointer;
  background-repeat: no-repeat;
}
.tool-btn {
  height: 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
